var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    _vm._l(_vm.tokens, function(token) {
      return _c(
        "span",
        {
          key: token.id,
          staticClass: "my-search-token",
          attrs: {
            role: "group",
            "aria-label": token.label + ": " + token.value
          }
        },
        [
          _vm._v(_vm._s(token.label)),
          token.label && token.value ? _c("span", [_vm._v(":")]) : _vm._e(),
          _vm._v(" " + _vm._s(token.value) + "\n\n    "),
          _c(
            "button",
            {
              staticClass: "close",
              attrs: {
                type: "button",
                tabindex: "0",
                "aria-label":
                  "Filter '" + token.label + ": " + token.value + "' entfernen"
              },
              on: {
                click: function($event) {
                  return _vm.closeToken(token)
                }
              }
            },
            [_vm._v("\n        ×\n    ")]
          )
        ]
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }